import styled from "styled-components";

import { FONT_SIZE, FONTS } from "../../../constants/Styles";

export const Page = styled.div`
  background-image: url("/images/vector_3.png");
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const Container = styled.div`
  max-width: 1200px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Title = styled.div`
  font-size: ${FONT_SIZE.size64};
  font-family: ${FONTS.spaceGrotesk};
  margin-bottom: 1rem;
  text-align: center;
`;
